/**
 * Utility functions to perform custom functions
 */

import showdown from 'showdown';

class Utils {

  /**
   * Get the HTML equivalent to Markdown text
   * @param {*} markdownText - Markdown text
   * @returns HTML equivalent to Markdown text
   */
  markdownToHtml = (markdownText) => {
    const converter = new showdown.Converter();
    return converter.makeHtml(markdownText);
  }

  /**
   * Function to format date string
   * @param {*} vDate 
   * @param {*} vFormat 
   * @returns 
   */
  formatDateString = (vDate, vFormat) => {

    const dtDate = new Date(vDate);
    let strDay;
    let strMonth;
    let strYear;
    let strDate = "";
    let strHour;
    let cstrHour;

    if (vFormat === 'Mmm DD, YYYY') {

      strDay = dtDate.toLocaleString('default', { day: '2-digit' });
      strMonth = dtDate.toLocaleString('default', { month: 'short' });
      strYear = dtDate.toLocaleString('default', { year: 'numeric' });

      strDate = `${strMonth} ${strDay}, ${strYear}`;

    } else if (vFormat === 'Mmm DD, YYYY HH:MM (UTC)') {

      strDay = dtDate.toLocaleString('default', { day: '2-digit' });
      strMonth = dtDate.toLocaleString('default', { month: 'short' });
      strYear = dtDate.toLocaleString('default', { year: 'numeric' });
      strHour = dtDate.toLocaleString('default', { hour: '2-digit', minute: '2-digit', hour12: true, });
      cstrHour = strHour.replace('am', 'AM').replace('pm', 'PM');

      strDate = `${strMonth} ${strDay}, ${strYear} ${cstrHour} (UTC)`;

    }
    return strDate;
  };
}
export default Utils;
